import React from "react";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-lg md:text-2xl font-semibold text-white">{title}</h2>
    <div className="text-sm md:text-base text-white/70 leading-relaxed space-y-3">
      {children}
    </div>
  </section>
);

export default function Terms() {
  return (
    <main className="min-h-screen bg-[#0b0b0b] text-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <h1 className="text-3xl md:text-5xl font-bold mb-3">Terms of Service</h1>

        <div className="space-y-10">
          <Section title="1. Who we are">
            <p>
              These Terms of Service ("Terms") govern your access to and use of
              Pluckr ("Pluckr", "we", "us"), including our website, dashboard,
              API, and any MCP (Model Context Protocol) products we provide.
            </p>
          </Section>

          <Section title="2. Your account">
            <p>
              You’re responsible for maintaining the confidentiality of your
              login credentials and for all activity under your account.
            </p>
            <p>
              You must provide accurate information and keep it up to date.
              Accounts may require email verification.
            </p>
          </Section>

          <Section title="3. API keys and access">
            <p>
              Pluckr may issue API keys for accessing MCP products or related
              services. API keys are personal to your account.
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Do not share or publish your API keys.</li>
              <li>
                If we detect that a key is compromised, we may disable it to
                protect you and the platform.
              </li>
              <li>
                Your plan determines which MCP products your API key can access.
              </li>
            </ul>
          </Section>

          <Section title="4. Acceptable use">
            <p>You agree not to misuse Pluckr. For example, you must not:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>probe, scan, or test the vulnerability of our systems;</li>
              <li>circumvent rate limits or access controls;</li>
              <li>use Pluckr to distribute malware or harmful code;</li>
              <li>interfere with other users’ access to the service.</li>
            </ul>
          </Section>

          <Section title="5. Payments and billing">
            <p>
              If you purchase a paid plan, payments may be processed by a
              third‑party payment provider (for example Razorpay). Your purchase
              may unlock additional MCP products.
            </p>
            <p>
              Fees are generally non‑refundable except where required by law or
              explicitly stated at purchase.
            </p>
          </Section>

          <Section title="6. Email and notifications">
            <p>
              We may send you transactional emails (e.g. verification, security,
              account notices). These are necessary to operate the service.
            </p>
          </Section>

          <Section title="7. Intellectual property">
            <p>
              Pluckr and its underlying software, branding, and content are
              owned by Pluckr and protected by applicable laws.
            </p>
          </Section>

          <Section title="8. Disclaimer">
            <p>
              Pluckr is provided "as is" and "as available". We don’t warrant
              that the service will be uninterrupted or error‑free.
            </p>
          </Section>

          <Section title="9. Limitation of liability">
            <p>
              To the maximum extent permitted by law, Pluckr will not be liable
              for indirect, incidental, special, consequential, or punitive
              damages, or any loss of profits, data, or goodwill.
            </p>
          </Section>

          <Section title="10. Termination">
            <p>
              You may stop using Pluckr at any time. We may suspend or terminate
              access if you violate these Terms or if needed to protect the
              service.
            </p>
          </Section>

          <Section title="11. Changes to these Terms">
            <p>
              We may update these Terms from time to time. If changes are
              material, we’ll take reasonable steps to notify you.
            </p>
          </Section>

          <Section title="12. Contact">
            <p>
              Questions about these Terms? Contact us at{' '}
              <a className="text-[#9be38f] hover:underline" href="mailto:support@pluckr.ai">
                support@pluckr.ai
              </a>.
            </p>
          </Section>
        </div>
      </div>
    </main>
  );
}
